/**
 * Aiká — Popup de captura de e-mail
 *
 * Aparece uma vez por sessão (depois de fechado, não insiste de novo
 * até a próxima visita) e nunca mais aparece pra quem já deixou o
 * e-mail (fica salvo em localStorage, sem prazo de expiração).
 *
 * O cadastro como Customer usa o formulário nativo de newsletter da
 * Shopify — MAS enviado de verdade (não via fetch), mirando num
 * <iframe> escondido em vez da janela principal. O formulário nativo
 * da Shopify tem proteção de captcha ativada por padrão, que bloqueia
 * submissões via fetch/AJAX; enviando como um formulário de verdade
 * (só que pro iframe, não pra página toda), a Shopify processa
 * normalmente sem a página principal recarregar.
 *
 * Como não dá pra ler o conteúdo do iframe de forma confiável (a
 * Shopify pode redirecionar por dentro dele de formas variadas), a
 * confirmação visual é otimista: assim que o navegador aceita o
 * envio, mostra o cupom. Isso é o mesmo padrão usado nos exemplos
 * de referência da própria comunidade Shopify pra esse problema.
 */
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-email-popup]');
  if (!popup) return;

  const EMAIL_KEY = 'aika_captured_email';
  const DISMISSED_KEY = 'aika_popup_dismissed';

  const alreadyHasEmail = localStorage.getItem(EMAIL_KEY);
  const dismissedThisSession = sessionStorage.getItem(DISMISSED_KEY);
  if (alreadyHasEmail || dismissedThisSession) return;

  const delaySeconds = parseFloat(popup.dataset.delay) || 6;

  const show = () => {
    popup.classList.add('is-visible');
  };

  const hide = () => {
    popup.classList.remove('is-visible');
    sessionStorage.setItem(DISMISSED_KEY, 'true');
  };

  const showTimer = setTimeout(show, delaySeconds * 1000);

  popup.querySelectorAll('[data-popup-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      clearTimeout(showTimer);
      hide();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
      hide();
    }
  });

  const form = popup.querySelector('[data-popup-form]');
  const formState = popup.querySelector('[data-popup-state="form"]');
  const successState = popup.querySelector('[data-popup-state="success"]');

  if (!form) return;

  form.addEventListener('submit', () => {
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput ? emailInput.value.trim() : '';
    if (!email) return;

    // Não intercepta o envio em si — deixa o navegador submeter de
    // verdade pro iframe escondido, só cuida da parte visual.
    const submitBtn = form.querySelector('.aika-email-popup__submit');
    if (submitBtn) submitBtn.disabled = true;

    localStorage.setItem(EMAIL_KEY, email);

    setTimeout(() => {
      if (formState) formState.hidden = true;
      if (successState) successState.hidden = false;
      clearTimeout(showTimer);
    }, 600);
  });

  const copyBtn = popup.querySelector('[data-popup-copy]');
  const codeEl = popup.querySelector('[data-popup-code]');
  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(codeEl.textContent.trim());
      } catch (error) {
        // Navegador sem suporte a clipboard API — seleciona o texto
        // como alternativa, pra pessoa copiar manualmente (Ctrl/Cmd+C).
        const range = document.createRange();
        range.selectNodeContents(codeEl);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        return;
      }

      const icon = copyBtn.querySelector('[data-popup-copy-icon]');
      const check = copyBtn.querySelector('[data-popup-copy-check]');
      const tooltip = copyBtn.querySelector('[data-popup-tooltip]');
      if (icon) icon.hidden = true;
      if (check) check.hidden = false;
      if (tooltip) tooltip.hidden = false;

      setTimeout(() => {
        if (icon) icon.hidden = false;
        if (check) check.hidden = true;
        if (tooltip) tooltip.hidden = true;
      }, 2000);
    });
  }
});
